import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getSecureItem, setSecureItem } from './utils/secureStorage';

import translationES from './locales/es/translation.json';
import translationEN from './locales/en/translation.json';
import translationJA from './locales/ja/translation.json';
import translationAR from './locales/ar/translation.json';
import translationDE from './locales/de/translation.json';
import translationHI from './locales/hi/translation.json';
import translationRU from './locales/ru/translation.json';
import translationZH from './locales/zh/translation.json';

const resources = {
  es: {
    translation: translationES
  },
  en: {
    translation: translationEN
  },
  ja: {
    translation: translationJA
  },
  ar: {
    translation: translationAR
  },
  de: {
    translation: translationDE
  },
  hi: {
    translation: translationHI
  },
  ru: {
    translation: translationRU
  },
  zh: {
    translation: translationZH
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getSecureItem<string>('language') || 'en',
    fallbackLng: 'en',
    
    interpolation: {
      escapeValue: false
    }
  });

// Guardar cambios de idioma en almacenamiento seguro
i18n.on('languageChanged', (lng) => {
  setSecureItem('language', lng);
});

export default i18n; 